import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Report.scss';

class Report extends Component {
  static propTypes = {
    id: PropTypes.any,
    name: PropTypes.string,
    lastModified: PropTypes.string,
    lastModifiedBy: PropTypes.string,
    reportLinkClick: PropTypes.func,
    scope: PropTypes.string
  };

  render() {
    const app =
      window.location.pathname.includes('/mp/') || window.location.pathname.endsWith('/mp')
        ? 'MarketPay'
        : 'Insight Lab';

    // 'global' maps to 'Standard' in the rw_report_scope table
    const isStandardScope = this.props.scope === 'global';
    const lastModifiedBy = isStandardScope ? app : this.props.lastModifiedBy;

    return (
      <div className="recent__report">
        <div className="recent__report--title" onClick={this.props.reportLinkClick}>
          {this.props.name}
        </div>
        <div className="recent__report--details">
          Last Modified {this.props.lastModified} - {lastModifiedBy}
        </div>
      </div>
    );
  }
}

export default Report;
